import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35b21975"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bigbox" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "mt-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-loading" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    t: "1651804570110",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "1827",
    width: "200",
    height: "200"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M864 480H544V160c0-17.67-14.33-32-32-32s-32 14.33-32 32v320H160c-17.67 0-32 14.33-32 32s14.33 32 32 32h320v320c0 17.67 14.33 32 32 32s32-14.33 32-32V544h320c17.67 0 32-14.33 32-32s-14.33-32-32-32z",
      "p-id": "1828",
      fill: "#ffffff"
    })
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 添加品牌 ")
const _hoisted_6 = { class: "tablebox" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_8 = { class: "dialog-footer" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_11 = {
  key: 0,
  class: "pushText"
}
const _hoisted_12 = {
  key: 1,
  class: "pushText"
}
const _hoisted_13 = { class: "dialog-footer" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("知道了")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Globalcontentarea = _resolveComponent("Globalcontentarea")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_MyTable = _resolveComponent("MyTable")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!
  const _component_Redprompt = _resolveComponent("Redprompt")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_MyUpload = _resolveComponent("MyUpload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Globalcontentarea, { isSlot: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.brandName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.brandName) = $event)),
              clearable: "",
              placeholder: "品牌名称/关键字",
              class: "input-with-select"
            }, {
              append: _withCtx(() => [
                _createVNode(_component_el_button, {
                  icon: _ctx.Search,
                  onClick: _ctx.searchForm
                }, null, 8, ["icon", "onClick"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createVNode(_component_el_button, {
            color: "#0981FF",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addClass())),
            round: ""
          }, {
            icon: _withCtx(() => [
              _hoisted_4
            ]),
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_MyTable, {
          isLoading: _ctx.isLoading,
          isHeight: false,
          tableData: _ctx.tableData,
          currentPage: _ctx.page.pageNum,
          pageSize: _ctx.page.pageSize,
          total: _ctx.page.total,
          isPagination: true,
          isIndex: true,
          tableColumn: _ctx.tableColumn,
          onHandleCurrentChange: _ctx.handleCurrentChange,
          onHandleSizeChange: _ctx.handleSizeChange
        }, {
          classImg: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "移动端logo",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_image, {
                  zIndex: 8888,
                  class: "classimg",
                  src: row.mobileLogo,
                  onClick: ($event: any) => (_ctx.changeImg(row.mobileLogo))
                }, null, 8, ["src", "onClick"])
              ]),
              _: 1
            })
          ]),
          accounttype: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "是否推送",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_switch, {
                  modelValue: row.isPush,
                  "onUpdate:modelValue": ($event: any) => ((row.isPush) = $event),
                  onChange: ($event: any) => (_ctx.switchFn(row))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
              ]),
              _: 1
            })
          ]),
          slotName: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "操作",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_button, {
                  color: "#0981FF",
                  onClick: ($event: any) => (_ctx.myclick(row)),
                  round: ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["isLoading", "tableData", "currentPage", "pageSize", "total", "tableColumn", "onHandleCurrentChange", "onHandleSizeChange"])
      ]),
      (_ctx.imgViewerVisible)
        ? (_openBlock(), _createBlock(_component_el_image_viewer, {
            key: 0,
            "url-list": [_ctx.imgurl],
            onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.imgViewerVisible = false))
          }, null, 8, ["url-list"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.FromDisplay,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.FromDisplay) = $event)),
        title: _ctx.DialogTitle,
        width: "665px",
        onClose: _ctx.handleClose
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_8, [
            _createVNode(_component_el_button, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.FromDisplay = false)),
              class: "cancelBtn"
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              loading: _ctx.btnLoading,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef)))
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ]),
        default: _withCtx(() => [
          (_ctx.DialogTitle == '新增品牌')
            ? (_openBlock(), _createBlock(_component_Redprompt, {
                key: 0,
                text: "说明： 新增品牌后需手动推送给各商户，品牌logo为移动端显示（小程序&APP）"
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form, {
            ref: "ruleFormRef",
            model: _ctx.FromData,
            rules: _ctx.modelrules,
            "label-width": "90px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "品牌名称",
                prop: "name"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.FromData.name,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.FromData.name) = $event)),
                    maxlength: "15",
                    placeholder: "请输入名称（限制15字内）"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "品牌logo",
                prop: "mobileLogo"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_MyUpload, {
                    imageUrl: _ctx.FromData.mobileLogo,
                    tipText: "上传一张JPG/PNG的图片，文件不超过1M 建议尺寸： 140 * 140 px",
                    onChangeImg: _ctx.uploadChangeImg,
                    onDelectImg: _ctx.delectImg
                  }, null, 8, ["imageUrl", "onChangeImg", "onDelectImg"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _: 1
      }, 8, ["modelValue", "title", "onClose"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.pushDisplay,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.pushDisplay) = $event)),
        title: _ctx.isPush ? '启用推送' : '禁用推送',
        width: "380px",
        onClose: _ctx.handleClose
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_13, [
            (_ctx.isPush)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.pushDisplay = false)),
                  class: "cancelBtn"
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.isPush)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  type: "primary",
                  onClick: _ctx.isPushSuccess
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (!_ctx.isPush)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 2,
                  type: "primary",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.pushDisplay = false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        default: _withCtx(() => [
          (_ctx.isPush)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, "启用推送后，商户端将自动接收该分类数据， 操作不可逆，确认要继续吗？"))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, "已开启推送，无法关闭"))
        ]),
        _: 1
      }, 8, ["modelValue", "title", "onClose"])
    ])
  ]))
}